var exports = {
  "o5": "xe564cbfb--ac0fcc--content-wrapper",
  "HE": "xe564cbfb--ac0fcc--button-wrapper",
  "aw": "xe564cbfb--ac0fcc--semi-transparent",
  "Sl": "xe564cbfb--ac0fcc--image",
  "W4": "xe564cbfb--ac0fcc--text-wrapper",
};

module.exports = exports;
